class Ano{
    constructor(ano = 0){
        this.ano= ano
        this.meses = [
            {
                nome:"Janeiro",
                id:1,
                dados:[]
            },
            {
                nome:"Fevereiro",
                id:2,
                dados:[]
            },
            {
                nome:"Março",
                id:3,
                dados:[]
            },
            {
                nome:"Abril",
                id:4,
                dados:[]
            },
            {
                nome:"Maio",
                id:5,
                dados:[]
            },
            {
                nome:"Junho",
                id:6,
                dados:[]
            },
            {
                nome:"Julho",
                id:7,
                dados:[]
            },
            {
                nome:"Agosto",
                id:8,
                dados:[]
            },
            {
                nome:"Setembro",
                id:9,
                dados:[]
            },
            {
                nome:"Outubro",
                id:10,
                dados:[]
            },
            {
                nome:"Novembro",
                id:11,
                dados:[]
            },
            {
                nome:"Dezembro",
                id:12,
                dados:[]
            },
        ]    
    }
}
export {Ano}
  